export const ErrorCodes = {
  CONTEST_ALREADY_STARTED: 'CONTEST_ALREADY_STARTED',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  WAGER_LIMIT_REACHED: 'WAGER_LIMIT_REACHED',
  WAGER_LIMIT_EXCEEDED: 'WAGER_LIMIT_EXCEEDED',
  WAGER_LIMIT_NOT_FOUND: 'WAGER_LIMIT_NOT_FOUND',
};

export const getErrorCode = (errorPayload) => {
  if (errorPayload?.ErrorCode)
    return errorPayload?.ErrorCode;

  // Add more evaluated error codes here
  if (errorPayload?.Reason === 'One or more contests have already started')
    return ErrorCodes.CONTEST_ALREADY_STARTED;
  if (errorPayload?.Reason === 'Insufficient balance')
    return ErrorCodes.INSUFFICIENT_FUNDS;
  if(errorPayload?.Reason === 'Wager limit for all sites reached')
    return ErrorCodes.WAGER_LIMIT_REACHED;
  if(errorPayload?.Reason === 'Wager Limit Exceeded')
    return ErrorCodes.WAGER_LIMIT_EXCEEDED;
  if(errorPayload?.Reason === 'Wager Limit not found')
    return ErrorCodes.WAGER_LIMIT_NOT_FOUND;
  //---

  return null;
};
export const getError = (source) => {
  const code = getErrorCode(source);
  if(code)
      return {code,
              source};
  return null;
}